<template>
	<div class="container">
		<div class="content">
			<div v-html="content"></div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Aboutus',
		components: {
			
		},
		data(){
			return {
				content: ''
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
			//获取关于我们数据
			async getDataList(){
				let param = {
					code: 'WEBSITE-ABOUT'
				}
				ajaxParam(param)
				const res = await post('website/index/getConfig', qs.stringify(param))
				if(res.data.code==200){
					this.content = res.data.entity.content
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	
</style>
